import { isString } from './runtime-values.js';
import type { SchemaInput } from './schema-input.js';

export const SATELLITE_POPUP_EXPERIMENT = 'satellite_popup_v1';
export const SATELLITE_POPUP_VARIANTS = new Set(['control', 'feature_demo']);
export const POPUP_EXPOSURE_ID_PATTERN = /^[a-f0-9]{64}$/;
export type SatellitePopupVariant = 'control' | 'feature_demo';
export interface SatellitePopupAttribution {
  popup_experiment: string;
  popup_variant: SatellitePopupVariant;
  popup_exposure_id: string;
}

export function satellitePopupAttribution(feature: SchemaInput, experiment: SchemaInput, variant: SchemaInput, id: SchemaInput): SatellitePopupAttribution | null {
  if (feature !== 'satellite_basemap' || experiment !== SATELLITE_POPUP_EXPERIMENT
    || (variant !== 'control' && variant !== 'feature_demo') || !isString(id) || !POPUP_EXPOSURE_ID_PATTERN.test(id)) return null;
  return { popup_experiment: experiment, popup_variant: variant, popup_exposure_id: id };
}
